import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
// import notify from '../../Notifications/ToastifyActions';
import notify from '../../../Notifications/ToastifyActions';

function AccountUpdateProfileService(token,data) {
    return axios.post(`${CURRENT_API_URL}/sellerPartner/accountUpdateProfile`, data, {
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        notify.NotifySuccess("Background Job for updating profiles for all users under this account has been fired successfully.Please wait for some time for data to reflect in the system.");       
        return res.data; // Correctly return the response data
    }).catch(error => {
        console.error(error);
        notify.NotifyError("An error occurred while updating profiles. Please try again later.");
        return false;
    });
}

export  default AccountUpdateProfileService